module.exports = __webpack_public_path__ + "static/media/akafoods.70a00b31.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/akafoods.webp
// module id = 488
// module chunks = 0